const delivery = (editor) => {

    editor.BlockManager.add('delivery', {
        category: 'Forms ',
        label: `
                    <svg  width="1.4vw" height="1.4vw" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path class="gjs-block-svg-path" d="M22,5.5 C22,5.2 21.5,5 20.75,5 L3.25,5 C2.5,5 2,5.2 2,5.5 L2,8.5 C2,8.8 2.5,9 3.25,9 L20.75,9 C21.5,9 22,8.8 22,8.5 L22,5.5 Z M21,8 L3,8 L3,6 L21,6 L21,8 Z" fill-rule="nonzero"></path>
                      <path class="gjs-block-svg-path" d="M22,10.5 C22,10.2 21.5,10 20.75,10 L3.25,10 C2.5,10 2,10.2 2,10.5 L2,13.5 C2,13.8 2.5,14 3.25,14 L20.75,14 C21.5,14 22,13.8 22,13.5 L22,10.5 Z M21,13 L3,13 L3,11 L21,11 L21,13 Z" fill-rule="nonzero"></path>
                      <rect class="gjs-block-svg-path" x="2" y="15" width="10" height="3" rx="0.5"></rect>
                    </svg>
                    <div class='gjs-fontFamily gjs-block-label'>Delivery Form</div>
                  `,
        attributes: {},
        content: `
        <div class="container py-5">
          <div class="row d-flex justify-content-center align-items-center">
            <div class="col">
              <div class="card my-4 shadow-lg">
                <div class="row g-0">
                  <div class="col-lg-5 col-md d-lg-inline-block rounded-3 h-100 bg-image">
                    <img src="https://images.pexels.com/photos/3434533/pexels-photo-3434533.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="Sample photo"
                      class="img-fluid rounded-3 h-100" />
                  </div>
                  <div class="col-lg-7 col-md">
                    <div class="card-body p-md-5 text-black">
                      <h3 class="mb-4 text-uppercase">Delivery Info</h3>
        
                      <div class="row">
                        <div class="col-md-6 mb-4">
                          <div class="form-outline">
                            <label class="form-label fw-bolder" for="form3Example1m">First name</label>
                            <input type="text" id="form3Example1m" placeholder="First Name" class="form-control form-control-lg " />
                          </div>
                        </div>
                        <div class="col-md-6 mb-4">
                          <div class="form-outline">
                            <label class="form-label fw-bolder" for="form3Example1n">Last name</label>
                            <input type="text" id="form3Example1n" placeholder="Last Name" class="form-control form-control-lg" />
                          </div>
                        </div>
                      </div>
        
                      <div class="form-outline mb-4">
                        <label class="form-label fw-bolder" for="form3Example8">Address</label>
                        <input type="text" id="form3Example8" placeholder="Address" class="form-control form-control-lg" />
                      </div>
        
        
        
                      <div class="row">
                        <div class="col-md-6 mb-4">
        
                          <select class="form-select">
                            <option value="1">State</option>
                            <option value="2">Option 1</option>
                            <option value="3">Option 2</option>
                            <option value="4">Option 3</option>
                          </select>
        
                        </div>
                        <div class="col-md-6 mb-4">
        
                          <select class="form-select">
                            <option value="1">City</option>
                            <option value="2">Option 1</option>
                            <option value="3">Option 2</option>
                            <option value="4">Option 3</option>
                          </select>
        
                        </div>
                      </div>
        
                      <div class="form-outline mb-4">
                        <label class="form-label fw-bolder" for="form3Example3">Zip</label>
                        <input type="text" id="form3Example3" placeholder="Zip" class="form-control form-control-lg" />
                      </div>
        
                      <div class="form-outline mb-4">
                        <label class="form-label fw-bolder" for="form3Example2">Email</label>
                        <input type="text" id="form3Example2" placeholder="Email" class="form-control form-control-lg" />
                      </div>
        
                      <div class="d-flex justify-content-end pt-3">
                        <button type="button" class="btn btn-success btn-lg ms-2">Place order</button>
                      </div>
        
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        `
    })
};

export default delivery;